export const commerceHostname = process.env.REACT_APP_COMMERCE_URL;
